import axios from 'axios';
import config from '../helpers/config';

export default (
  addressId,
  propertyId,
  customerId,
  measureAndInstallEstimate,
  itemsWithExtraQuantity,
) => {
  const url = `${config.mandiBaseUrl.replace(/\/$/, '')}${config.createMandiEstimateApi}`;

  const payload = {
    addressId,
    propertyId,
    customerId,
    ...measureAndInstallEstimate,
    itemsWithExtraQuantity,
  };

  return axios.post(url, payload);
};
